module.exports = __webpack_public_path__ + "static/media/overlap.aa0a46a4.svg";